import { Component, OnInit, Output, EventEmitter, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-task',
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.scss']
})
export class TaskComponent implements OnInit {

  showCreateTask:boolean = true;
  PI:boolean = true;
  showTaskDetail:boolean = true;

  constructor(  private dialog: MatDialog,) { }

  ngOnInit(): void {
  }

  @Output() createTask = new EventEmitter<boolean>()
  @Output() showLinkPI = new EventEmitter<boolean>()
  @Output() taskDetail = new EventEmitter<boolean>()

  createNewTask(message:boolean){
    this.createTask.emit(message)
  }

  addPI(message:boolean){
    this.showLinkPI.emit(message)
  }

  opentaskDetail(message:boolean){
    this.taskDetail.emit(message)
  }

  addFolder(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef);
  }
  

}
